import { render, staticRenderFns } from "./PartyCard.vue?vue&type=template&id=67b58481"
import script from "./PartyCard.vue?vue&type=script&lang=js"
export * from "./PartyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports